import fetch from "auth/FetchInterceptor";
import store from "redux/store";
import { UPDATE_NOTIFICATIONS } from "redux/constants/Menu";
import { UPDATE_PERMISSOES } from "redux/constants/Permissoes";
import { UPDATE_USER } from "redux/constants/User";
import { SELECTED_TENANT_STORAGE_KEY } from "configs/AppConfig";

const MenuService = {};

/*
    Injeta na store do usuário os dados do menu
*/
MenuService.populateMenuData = async function () {
	const menuData = await MenuService.getMenuData();

	const tenants = menuData.tenants || [];
	const fromLs = localStorage.getItem(SELECTED_TENANT_STORAGE_KEY);
	let selectedTenant = null;

	if (tenants.length === 0) {
		localStorage.removeItem(SELECTED_TENANT_STORAGE_KEY);
	} else {
		const validValues = tenants.map((t) => String(t.id));
		if (fromLs && validValues.includes(fromLs)) {
			selectedTenant = fromLs;
		} else {
			selectedTenant = String(tenants[0].id);
		}
		localStorage.setItem(SELECTED_TENANT_STORAGE_KEY, selectedTenant);
	}

	store.dispatch({
		type: UPDATE_USER,
		name: menuData.usuario.nome,
		role: "Usuário",
		tenants,
		selectedTenant,
		idGrupoUsuario: menuData.usuario?.id_grupo_usuario ?? null,
	});

	store.dispatch({
		type: UPDATE_NOTIFICATIONS,
		empresasComErros: menuData.notificacoes.total_empresas_com_erros,
	});

	store.dispatch({
		type: UPDATE_PERMISSOES,
		permissoes: menuData.permissoes,
	});
};

// TODO: após clonar o skeleton, ajustar essa função
MenuService.getMenuData = function () {
	return fetch({
		url: "/v1/rpc/menu",
		method: "get",
	});
};

export default MenuService;
